import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import './CallModal.css';

const CallModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const { language } = useLanguage();
  const t = translations[language].callModal;

  useEffect(() => {
    // Check if modal has already been shown in this session
    const modalShown = sessionStorage.getItem('callModalShown');
    if (modalShown) {
      setHasShown(true);
      return;
    }

    const handleScroll = () => {
      // Check if user has scrolled to bottom
      const scrollPosition = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      
      // Trigger when user is within 100px of the bottom
      if (scrollPosition >= pageHeight - 100 && !hasShown) {
        setIsVisible(true);
        setHasShown(true);
        sessionStorage.setItem('callModalShown', 'true');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasShown]);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleBookCall = () => {
    window.open('https://calendly.com/salesgod/scaleup-team-call', '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="call-modal-overlay" onClick={handleClose}>
      <div className="call-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="call-modal-close" onClick={handleClose}>
          <img src="./img/x.svg" alt="Close" />
        </button>
        
        <div className="call-modal-header">
          <div className="call-modal-icon">
            <img src="./img/bonusclub_logo.svg" alt="Bonusclub" className="call-modal-logo" />
          </div>
          <h2 className="call-modal-title">{t.title}</h2>
          <p className="call-modal-subtitle">{t.subtitle}</p>
        </div>

        <div className="call-modal-body">
          <div className="call-modal-benefits">
            <div className="call-modal-benefit">
              <img src="./img/check.webp" alt="Check" className="call-modal-check" />
              <span dangerouslySetInnerHTML={{ __html: t.benefit1 }} />
            </div>
            <div className="call-modal-benefit">
              <img src="./img/check.webp" alt="Check" className="call-modal-check" />
              <span dangerouslySetInnerHTML={{ __html: t.benefit2 }} />
            </div>
            <div className="call-modal-benefit">
              <img src="./img/check.webp" alt="Check" className="call-modal-check" />
              <span dangerouslySetInnerHTML={{ __html: t.benefit3 }} />
            </div>
          </div>
        </div>

        <div className="call-modal-footer">
          <button className="call-modal-btn-primary" onClick={handleBookCall}>
            <span className="call-modal-btn-text">{t.bookCall}</span>
            <span className="call-modal-btn-badge">{language === 'de' ? 'GRATIS' : 'FREE'}</span>
          </button>
          <button className="call-modal-btn-secondary" onClick={handleClose}>
            {t.notNow}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CallModal;

